import { render, staticRenderFns } from "./createMatrix.vue?vue&type=template&id=75b0b354"
import script from "./createMatrix.vue?vue&type=script&lang=js"
export * from "./createMatrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports